module.exports = __webpack_public_path__ + "static/media/jade.d58d6184.png";